import { classnames } from '@aibees/shared/utils';
import { Typography, useTheme } from '@mui/material';
import { memo } from 'react';
import { useContactDetailsState } from '../../context';
import * as Styled from './styles';
import * as SX from './sx';
import type { ContactDetailsFailedContentProps as Props } from './types';

export const ContactDetailsFailedContent = memo(({ className }: Props) => {
  const theme = useTheme();
  const { failed } = useContactDetailsState();

  if (!failed) return null;

  return (
    <Styled.Wrapper
      className={classnames('ContactDetailsFailedContent', className)}
      sx={SX.root}
      gap={2}
      pt={1}
    >
      <Typography
        variant="body4"
        color={theme.palette.common.black}
        alignSelf="center"
      >
        <b>Hmm, it looks like something went wrong. Let`s try again</b>
        <br />
        No Credits were deducted
      </Typography>
      <Typography
        variant="body4"
        color={theme.palette.grey[500]}
        alignSelf="center"
      >
        If you believe this is an error, please{' '}
        <a
          href=""
          target="_blank"
          style={{ color: theme.palette.primary[500] }}
        >
          <b>Contact Support.</b>
        </a>
      </Typography>
    </Styled.Wrapper>
  );
});

ContactDetailsFailedContent.displayName = 'ContactDetailsFailedContent';
